import React from "react";

import { Loader } from "../../../../components/Loaders/Loader/Loader";

import styles from "./styles.module.scss";

const StepsMultiColumn = ({ isLoading, controls, iframes }) => {

    if(isLoading) {
        return <Loader/>;
    }

    return (
        <div className={styles.step}>
            <div className={styles.dataWrapper}>
                <div className={styles.data}>
                    {controls}
                </div>
            </div>

            <div className={styles.iframeBlock}>
                {iframes}
            </div>
        </div>
    );
};

export default StepsMultiColumn;
